// extracted by mini-css-extract-plugin
export default {"modalHeader":"uba-z","modalContent":"vba-z","formWrapper":"wba-z","fade":"xba-z","fade-in":"yba-z"};